import { SortableWidgetProps, Widget } from '@creditsights/styleguide-web';
import { ReactElement, forwardRef } from 'react';
import useFetchSnippet from '../../../hooks/snippets/useFetchSnippet';
import { SnippetType } from '../../../models';

const CustomDeal = (props: SortableWidgetProps, ref): ReactElement | null => {
  const { data: snippet } = useFetchSnippet(SnippetType.BOILER_PLATE, 'account_support');

  if (!snippet) {
    return null;
  }

  return (
    <Widget headerTitle="Questions?" dataTestId="account-support" ref={ref} {...props}>
      <div dangerouslySetInnerHTML={{ __html: snippet.body }} />
    </Widget>
  );
};

export default forwardRef(CustomDeal);
